import React from "react";
import {
  CustomTextInput,
} from "../../components";
import styles from "./SampleInputUsage.module.css";

const SampleInputUsage = () => {
  return (
    <div className={styles.formContainer}>
      <div className={styles.formCard}>
        <div className={styles.formHeader}>
          <h2 className={styles.formTitle}>Sample Registration Form</h2>
          <p className={styles.formSubtitle}>
            Please fill in all the required fields
          </p>
        </div>

        <form className={styles.form}>
          {/* Personal Information Section */}
          <div className={styles.section}>
            <CustomTextInput
              label="Username"
              name="username"
              // value={username}
              // onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
            />
            <CustomTextInput
              label="Password"
              type="password"
              name="password"
              // value={password}
              // onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />

            <CustomTextInput
              label="Email"
              type="email"
              name="email"
              // value={email}
              // onChange={(e) => setEmail(e.target.value)}
              error="Please enter a valid email address"
              required
            />
            <CustomTextInput
              label="Search"
              name="search"
              // value={search}
              // onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              icon={<span class="material-symbols-outlined">search</span>}
              iconPosition="left"
            />
            <CustomTextInput
              label="Email"
              type="email"
              name="email"
              // value={email}
              // onChange={(e) => setEmail(e.target.value)}
              icon={<span class="material-symbols-outlined">mail</span>}
              iconPosition="right"
            />
            <CustomTextInput label="Small" size="sm" name="small" />
            <CustomTextInput label="Medium" size="md" name="medium" />
            <CustomTextInput label="Large" size="lg" name="large" />
            <CustomTextInput
              label="Disabled Input"
              name="disabled"
              value="Cannot edit this"
              disabled
            />
            <CustomTextInput
              label="Read Only"
              name="readonly"
              value="Read only value"
              readOnly
            />
            <CustomTextInput
              label="Username"
              name="username"
              helperText="Username must be 3-20 characters"
              maxLength={20}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SampleInputUsage;
